<gp-modal #repSettingsModal gp-modal="reportDefinitionModal" [closable]="false" [size]="isFormDisplayed ? 'lg' : 'sm'">
  <div class="gp-modal-title">
    <h4>{{ selectedReportDefinition?.descriptionTransId | translate }}</h4>
  </div>
  <div class="gp-modal-body clearfix" gpMvel [contractId]="contractId" [mvelAliases]="mvelAliases">
    <gp-generated-simple-form
      [groupZoneDescriptor]="reportDefinitionDescriptor"
      [values]="reportDefinitionValues"
      [setDefaultTodayForDate]="true"
      (formStabilised)="reportDefinitionFormLoaded()">
    </gp-generated-simple-form>

    <p *ngIf="!isFormDisplayed">
      {{ 'COMMON.confirm_request' | translate }}
    </p>

    <div [innerHtml]="reportDefinitionPreview.iframe" *ngIf="displayPreview && reportDefinitionPreview">
    </div>
  </div>
  <div class="gp-modal-footer">
    <button type="button"
            *ngIf="selectedReportDefinition && !reportDefinitionPreview"
            [disabled]="generatedSimpleForm && generatedSimpleForm.form?.invalid || reportDefinitionRunning"
            class="btn btn-dark p-x-md"
            (click)="actionReport(repSettingsModal)">
            <ng-container *ngIf="reportDefinitionRunning; else actionButton">
              <em class="fa fa-light fa-spinner fa-spin"></em>
            </ng-container>
            <ng-template #actionButton>
              {{ getActionButton(selectedReportDefinition) }}
            </ng-template>
    </button>
    <a *ngIf="reportDefinitionPreview"
       class="btn btn-dark p-x-md"
       target="_blank"
       rel="noopener"
       (click)="download()"
       [href]="reportDefinitionPreview.href"
       [download]="reportDefinitionPreview.download">
      {{ 'FORM_GENERATOR.MODALS.BUTTONS.download' | translate }}
    </a>
    <button type="button"
            class="btn btn-secondary p-x-md"
            [disabled]="reportDefinitionRunning"
            (click)="cancel()">
      {{ 'FORMS.cancel' | translate }}
    </button>
  </div>
</gp-modal>
